<template>
	<dashboard-panel
		:title="mode === 'alerts' ? 'Alerts' : 'Chat log'"
		:edit-mode="editMode"
		:popout-url="mode === 'alerts' ? '/app/alerts.html' : '/app/chat.html'"
		@remove="$emit('remove')"
	>
		<chat-log v-if="mode === 'chat'" class="flex-fill" :serviceIcons="serviceIcons" ref="chatLog"></chat-log>
		<alert-log v-else class="flex-fill" :serviceIcons="serviceIcons" ref="alertLog"></alert-log>
	</dashboard-panel>
</template>

<script>
import DashboardPanel from '../DashboardPanel.vue';
import ChatLog from '../ChatLog.vue';
import AlertLog from '../AlertLog.vue';

export default {
	name: 'LogPanel',
	components: { DashboardPanel, ChatLog, AlertLog },
	props: {
		editMode: { type: Boolean, default: false },
		mode: { type: String, default: 'chat' }, // 'chat' | 'alerts'
		serviceIcons: { type: Object, default: () => ({}) },
	},
	methods: {
		// Exposed so the parent can scroll the chat log after channel updates.
		bottomOut() { this.$refs.chatLog?.bottomOut?.(); },
	},
};
</script>
